import { render, staticRenderFns } from "./CodificationSearcherModal.vue?vue&type=template&id=161e5ac0&scoped=true&"
import script from "./CodificationSearcherModal.vue?vue&type=script&lang=js&"
export * from "./CodificationSearcherModal.vue?vue&type=script&lang=js&"
import style0 from "./CodificationSearcherModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161e5ac0",
  null
  
)

export default component.exports